import {useState} from "react";
import axios from 'axios';
import Swal from 'sweetalert2';
import {useNavigate} from 'react-router-dom';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function PatientRegister() {
    const navigate = useNavigate();
    const [errorMsg, seterrorMsg] = useState('');
    const [gender, setGender] = useState("male"); // set default value to "male"
    const [succesMsg, setsuccessMsg] = useState('');
    const [registerFormData, setRegisterFormData] = useState({
        "pat_id": '',
        "my_title": '',
        "patient": '',
        "age": '',
        "mobile": '',
        "address1": '',
        "gender": '',
        "refered": '',
        "status": '',
        "addedby": '',
        "ip_add": '',
    });
    const handleInputChange = (event) => {
        setGender(event.target.value);
    };
    const inputHandler = (event) => {
        setRegisterFormData({
            ...registerFormData,
            [event.target.name]: event.target.value
        })
    };
    const submitHandler = (e) => {
        e.preventDefault();
        axios.post(`${baseUrl}get_pat_id/`)
            .then(response => {
                const pat_id = response.data.value;
                const formData = new FormData();
                const refered = document.getElementById("refered").value;
                const title = document.getElementById("title").value;
                formData.append('pat_id', pat_id);
                formData.append('my_title', title);
                formData.append('patient', registerFormData.patient);
                formData.append('age', registerFormData.age);
                formData.append('gender', gender);
                formData.append('mobile', registerFormData.mobile);
                formData.append('address1', registerFormData.address);
                formData.append('refered', refered);
                formData.append('status', '1');
                formData.append('addedby', userName);
                formData.append('ip_add', ipAddress);
                formData.append('location', userLocation);
                axios.post(baseUrl + 'add-patient/', formData)
                    .then((response) => {
                        if (response.status == 200 || response.status == 201) {
                            Swal.fire({
                                title: 'Patient has been added.',
                                text: `Patient ID : ${pat_id}`,
                                icon: 'success',
                                timer: 2000,
                                showConfirmButton: false
                            });
                            setRegisterFormData({
                                pat_id: '',
                                title: '',
                                patient: '',
                                age: '',
                                gender: '',
                                mobile: '',
                                address1: '',
                                refered: '',
                                status: '',
                                addedby: '',
                                ip_add: '',
                            });
                            setTimeout(() => {
                                window.location.href = '/add-patient/';
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        Swal.fire(
                            'Error!',
                            'Failed to add Patient. Please try again later.',
                            'error'
                        );
                    });
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed to generate unique value. Please try again later.',
                    'error'
                );
            });
    };
    const buttonEnable = (registerFormData.patient != '') && (registerFormData.age != '') && (registerFormData.mobile != '')
    return (
        <section className="container mt-4">
            <div className="row">
                <div className="col-md-8 col-12">
                    <div className='card'>
                        <h4 className='card-header text-center'>New Patient Registration</h4>
                        <div className='card-body'>
                            <p className="text-muted"><strong>Note:</strong>All are Mandatory Fields</p>
                            {succesMsg && <p className="text-success">{succesMsg}</p>}
                            {errorMsg && <p className="text-danger">{errorMsg}</p>}
                            <form>
                                <div className="row">
                                    <label htmlFor="Role" className="form-label">Patient Name</label>
                                    <div className="col-md-3 mb-3">
                                        <select className="form-control" value={registerFormData.title}
                                                onChange={inputHandler}
                                                name="title" id="title">
                                            <option value="Mr">Mr</option>
                                            <option value="Mrs">Mrs</option>
                                            <option value="Master">Master</option>
                                            <option value="Dr">Dr</option>
                                            <option value="Baby">Baby</option>
                                            <option value="Ms">Ms</option>
                                        </select>
                                    </div>
                                    <div className="col-md-9 mb-3">
                                        <input type="text" placeholder="Patient Name" className="form-control"
                                               name="patient" value={registerFormData.patient} onChange={inputHandler}/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Age" className="form-label">Age</label>
                                        <input type="text" placeholder="Age" className="form-control"
                                               name="age" value={registerFormData.age} onChange={inputHandler}/>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Mobile" className="form-label">Mobile</label>
                                        <input type="number" maxLength={10} placeholder="Mobile"
                                               className="form-control"
                                               name="mobile" value={registerFormData.mobile} onChange={inputHandler}/>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="Address" className="form-label">Address</label>
                                        <input type="text" placeholder="Address" className="form-control"
                                               name="address" value={registerFormData.address} onChange={inputHandler}/>
                                    </div>
                                </div>
                                <div className="row">

                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="Gender" className="form-label">Gender</label>
                                        <label className="radio-inline">

                                            <input type="radio" name="gender" value="male" checked={gender === "male"}
                                                   onChange={handleInputChange}/> Male
                                        </label>
                                        <label className="radio-inline">
                                            <input type="radio" name="gender" value="female"
                                                   checked={gender === "female"}
                                                   onChange={handleInputChange}/> Female
                                        </label>
                                        <label className="radio-inline">
                                            <input type="radio" name="gender" value="transgender"
                                                   checked={gender === "transgender"}
                                                   onChange={handleInputChange}/> Transgender
                                        </label>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Refered" className="form-label">Referred By</label>
                                        <select className="form-control" value={registerFormData.refered}
                                                onChange={inputHandler}
                                                name="refered" id="refered">
                                            <option value="walkin">Walk-in</option>
                                            <option value="medicalcamp">Medical Campaign</option>
                                            <option value="friends">Friends</option>
                                            <option value="doctor">Doctor</option>
                                            <option value="paperad">Paper Adv</option>
                                            <option value="others">Others</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 text-center">
                                        <button type="button" disabled={!buttonEnable} onClick={submitHandler}
                                                className="btn btn-success">Register
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
export default PatientRegister;
